module.exports = __webpack_public_path__ + "img/alert.7c662c12.png";